import axios, { AxiosInstance, AxiosError, InternalAxiosRequestConfig, AxiosResponse, AxiosRequestHeaders } from 'axios';
import { RespBody } from '@/requests/types';
import { ElMessage } from 'element-plus';
import router from '@/router';

interface Result {
    errcode: number,
    errmsg: string,
}

// export const baseUrl = 'https://127.0.0.1:5443'
// export const baseUrl = 'https://192.168.253.141:5443'
export const baseUrl = '/api'
export const APIUrl = baseUrl + "/v1";
export const fileUrl = baseUrl + "/static/";
export const tgStaticUrl = baseUrl + "/static/tg/"
export const skypeStaticUrl = baseUrl + "/static/skype/"
export const wechatStaticUrl = baseUrl

enum RequestEnums {
    TIMEOUT = 20000,
    SUCCESS_CODE = 0,
    HTTP_SUCCESS_CODE = 200,
    UNAUTH_CODE = 401,

    NOT_FOUND_CODE = 404,
}

const config: InternalAxiosRequestConfig = {
    baseURL: APIUrl as string,
    timeout: RequestEnums.TIMEOUT as number,
    withCredentials: true,
    headers: {} as AxiosRequestHeaders,
}

const handleUnAuth = () => {
    // Processing unAuthed situation.
    const at_l_token = localStorage.getItem("at_l_token");
    if (at_l_token) {
        localStorage.removeItem("at_l_token");
        ElMessage.error("凭证失效，请重新登录");
    }
    router.push('/login')
}

class RequestHttp {
    service: AxiosInstance;

    public constructor(config: InternalAxiosRequestConfig) {
        this.service = axios.create(config);

        this.service.interceptors.request.use(
            (config: InternalAxiosRequestConfig) => {
                const token = localStorage.getItem('at_l_token');
                if (token) {
                    config.headers['Authorization'] = `Bearer ${token}`
                }
                return config;
            },
            (err: AxiosError) => {
                ElMessage.error(err.message);
                return Promise.reject(err);
            }

        );

        this.service.interceptors.response.use(
            (response: AxiosResponse) => {
                const rawData: RespBody | string = response.data;

                if (response.config.responseType === "blob") {
                    return response
                }

                // string left to maintain the compatibility
                if (typeof rawData === 'string') {
                    ElMessage.error(rawData.toString());
                } else if (rawData.code === RequestEnums.SUCCESS_CODE) {
                    return rawData.data;
                } else if (rawData.code === RequestEnums.UNAUTH_CODE) {
                    handleUnAuth();
                    return Promise.reject(rawData.msg);
                } else {
                    ElMessage.error(rawData.msg);
                    return Promise.reject(rawData.msg);
                }
            },
            (err: AxiosError) => {
                const { response } = err;
                if (response && response.status === RequestEnums.UNAUTH_CODE) {
                    handleUnAuth();
                }

                if (!window.navigator.onLine) {
                    ElMessage.error('网络连接失败');
                }
            },
        );
    }


    get<T>(url: string, params?: object): Promise<T> {
        return this.service.get(url, { params });
    }

    post<T>(url: string, params?: object): Promise<T> {
        return this.service.post(url, JSON.stringify({ data: params }));
    }

    download<T>(url: string, params?: object, filename?: string): Promise<void | T> {
        return this.service.get(url, {
            params,
            responseType: 'blob'
        }).then(response => {
            console.log(response);
            const blob = new Blob([response.data], { type: 'application/octet-stream' });
            const downloadElement = document.createElement('a');
            const href = window.URL.createObjectURL(blob);
            downloadElement.href = href;
            let fileNameFromHeader = undefined;
            if (response.headers['content-disposition']) {
                fileNameFromHeader = response.headers['content-disposition'].split('=')[1];
            }
            downloadElement.download = filename || fileNameFromHeader;
            document.body.appendChild(downloadElement);
            downloadElement.click();
            document.body.removeChild(downloadElement);
            window.URL.revokeObjectURL(href);
        });
    }
}

export default new RequestHttp(config);
